export default __webpack_public_path__ + "static/media/antp_coloquio_FranciscoKim.a6c43324.png";